import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        // Resume slightly before the video enters so playback is already going when it appears.
        // Off-screen autoplay keeps decoding for the whole page otherwise.
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries.at(-1).isIntersecting) {
                    this.play()
                } else {
                    this.element.pause()
                }
            },
            { rootMargin: '200px' },
        )
        this.observer.observe(this.element)
    }

    disconnect() {
        this.observer?.disconnect()
        this.observer = null
    }

    play() {
        if (this.element.paused) {
            this.element.play().catch((error) => {
                if (error?.name === 'AbortError') return
                console.error('Video play failed:', error)
            })
        }
    }
}
